"use stric"

import api from './apiService.js'
import WithToken from './tokenService'
import configuration from './../../config.json'

var CarsBrandsService = {
  getCarsBrands: function () {
    return api.get('/unitbrands', WithToken.headersToken(
      {},
      configuration.cookieName
    ))
  },
}

export default CarsBrandsService